<template>
	<div>
		<Sidebar></Sidebar>
		<Header></Header>
		<b-container fluid>
			<b-row>
				<b-col>
					<h3 class="my-4">Posts:</h3>
				</b-col>
				<b-col>
					<b-button
						class="f-right my-4"
						variant="outline-primary"
						@click="newRow"
						>Novo</b-button
					>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="12">
					<b-table striped hover :items="items" :fields="fields">
						<template slot="top-row">
							<td></td>
							<td>
								<b-form-input
									v-model="title"
									aria-describedby="input-live-help input-live-feedback"
									trim
								>
								</b-form-input>
							</td>
							<td></td>
							<td>
								<b-form-select
									v-model="spotlight"
									:options="spotlightOptions"
								></b-form-select>
							</td>
							<td>
								<b-form-select
									v-model="approvalStatus"
									:options="statusOptions"
								></b-form-select>
							</td>
							<td>
								<b-button variant="outline-primary" @click="filterList()">
									Filtrar
								</b-button>
							</td>
						</template>
						<template slot="editar" slot-scope="data">
							<a :href="'#/post/' + data.item.id">
								<i class="fas fa-edit"></i>
							</a>
						</template>
						<template slot="image" slot-scope="data">
							<img class="table-image" :src="data.item.image" />
						</template>
						<template slot="spotlight" slot-scope="data">
							{{ booleanText(data.item.spotlight) }}
						</template>
						<template slot="active" slot-scope="data">
							{{ booleanText(data.item.active) }}
						</template>
						<template slot="approvalStatus" slot-scope="data">
							<span :class="data.item.approvalStatus.toLowerCase()">{{
								data.item.approvalStatus
							}}</span>
						</template>
						<template slot="excluir" slot-scope="data">
							<i
								@click="removeObj(data.item)"
								class="fas fa-trash-alt danger"
							></i>
						</template>
					</b-table>

					<div v-show="loading" class="loading-holder">
						<div class="loading-spinner"></div>
					</div>
				</b-col>
			</b-row>

			<v-pagination
				class="f-right mt-3"
				v-model="currentPage"
				:page-count="pages"
			></v-pagination>
		</b-container>
	</div>
</template>

<script>
import http from "@/http";
import router from "@/router";
import authentication from "../util/authentication";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import vPagination from "vue-plain-pagination";

export default {
	name: "Post",
	data() {
		return {
			title: "",
			spotlight: null,
			approvalStatus: "",
			entity: {
				eng: "Post",
				por: "Post",
			},
			spotlightOptions: [
				{ value: null, text: "Todos" },
				{ value: true, text: "Sim" },
				{ value: false, text: "Não" },
			],
			statusOptions: [
				{ value: "", text: "Todos" },
				{ value: "Pendente", text: "Pendente" },
				{ value: "Aprovado", text: "Aprovado" },
				{ value: "Reprovado", text: "Reprovado" },
			],
			fields: [
				"editar",
				{
					key: "title",
					label: "Title",
					sortable: false,
				},
				{
					key: "image",
					label: "Imagem",
					sortable: false,
				},
				{
					key: "spotlight",
					label: "Destaque",
					sortable: false,
				},
				{
					key: "approvalStatus",
					label: "Status",
					sortable: false,
				},
				"excluir",
			],
			items: [],
			currentPage: 1,
			pages: 1,
			loading: true,
		};
	},
	components: {
		Sidebar,
		Header,
		Footer,
		vPagination,
	},
	methods: {
		removeObj(obj) {
			if (
				confirm(
					`Tem certeza que deseja deletar o ${this.entity.por} "${obj.title}"`
				)
			) {
				http
					.delete(`${this.entity.eng}/${obj.id}`, authentication.getHeaders())
					.then((response) => {
						this.list();
					});
			}
		},
		filterList() {
			if (this.currentPage === 1) {
				this.list();
			} else {
				this.currentPage = 1;
			}
		},
		list() {
			var params = `page=${this.currentPage - 1}&title=${
				this.title
			}&spotlight=${this.spotlight}&approvalStatus=${this.approvalStatus}`;

			if (!authentication.isAdmin()) {
				var user = authentication.getUser();
				if (user) {
					params += `&user=${user.info.id}`;
				}
			}

			http
				.get(`${this.entity.eng}?${params}`, authentication.getHeaders())
				.then((res) => {
					this.items = res.data.list;
					this.pages = res.data.pages;
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		newRow() {
			router.push(`/${this.entity.por}/novo`);
		},
		booleanText(value) {
			return value ? "Sim" : "Não";
		},
	},
	created() {
		this.list();
	},
	watch: {
		currentPage() {
			this.list();
		},
	},
};
</script>

<style scoped>
.table-image {
	width: 100px;
	max-height: 100px;
}

.aprovado {
	color: darkgreen;
	font-weight: bold;
}

.reprovado {
	color: darkred;
	font-weight: bold;
}

.pendente {
	color: orangered;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Post.vue